import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { fetchFeatureRequests } from "../../../views/FeatureRequests/featureRequestsApi";
import WidgetFrame, { WidgetEmpty, WidgetStat } from "./WidgetFrame";

// Triage counts for the feature-request queue (Admin/IT only, via catalog
// roles — the API also checks the x-user-id header server-side).
const FeatureRequestsWidget = () => {
  const user = useSelector(selectUser);
  const [requests, setRequests] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    fetchFeatureRequests(user.id)
      .then((list) => setRequests(Array.isArray(list) ? list : []))
      .catch(() => setFailed(true));
  }, [user?.id]);

  const count = (status) =>
    requests.filter((request) => request.status === status).length;

  return (
    <WidgetFrame title="Feature Requests" to="/admin/feature-requests">
      {requests ? (
        <div className="grid grid-cols-3 gap-2">
          <WidgetStat value={count("new")} label="New" />
          <WidgetStat value={count("planned")} label="Planned" />
          <WidgetStat value={count("in_progress")} label="In progress" />
        </div>
      ) : (
        <WidgetEmpty>
          {failed ? "Couldn't load requests." : "Loading requests…"}
        </WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default FeatureRequestsWidget;
